import { CREATE, UPDATE, RETRIEVE, DELETE } from "./actionTypes";

export const createBook = (book) => {
  return {
    type: CREATE,
    payload: {
      ...book,
    },
  };
};

export const retrieveBooks = (books) => {
  return {
    type: RETRIEVE,
    payload: [...books],
  };
};

export const updateBook = (book) => {
  return {
    type: UPDATE,
    payload: book,
  };
};

export const deleteBook = (id) => {
  return {
    type: DELETE,
    payload: id,
  };
};
